import { render, staticRenderFns } from "./Shading.vue?vue&type=template&id=03174513&scoped=true&"
import script from "./Shading.vue?vue&type=script&lang=js&"
export * from "./Shading.vue?vue&type=script&lang=js&"
import style0 from "./Shading.vue?vue&type=style&index=0&id=03174513&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03174513",
  null
  
)

export default component.exports